import { useEffect, useRef, useState } from "react";
import "./setting.css";
import Layout from "../../layout";
import Rate from "antd/lib/rate";
import Input from "antd/lib/input";
import TextArea from "antd/lib/input/TextArea";
import Select from "antd/lib/select";
import Button from "antd/lib/button";
import useSetting from "../../hooks/use_setting";
import { useSelector } from "react-redux";
import LoadingBlack from "../../assets/animations/loading_black.svg";
import showFile from "../../helpers/show_file";
import Skeleton from "../../components/skeleton";
import { GendersEnum, InstructorSocialMediaEnum } from "../../utils/enums";
import Tabs from "antd/lib/tabs";
import { FaPlus } from "react-icons/fa6";
import Modal from "antd/lib/modal";
import { IoClose } from "react-icons/io5";
import { FaExternalLinkAlt } from "react-icons/fa";
import { CiMenuKebab } from "react-icons/ci";
import Dropdown from "antd/lib/dropdown";

const Setting = () => {
  const {
    // entity methods
    getCountries,
    getCategories,
    updateAvatar,
    deleteSocialMedia,
    // controller methods
    updateSettingController,
    updatePasswordController,
    addSocialMediaController,
    updateSocialMediaController,
    // entity states
    countries,
    categories,
    socialMediaAccounts,
    // controller states
    newAccountModal,
    setNewAccountModal,
    updateAccountModal,
    setUpdateAccountModal,
    deleteAccountModal,
    setDeleteAccountModal,
    selectedSocialMedia,
    setSelectedSocialMedia,
    // loading states
    loadings,
    getCountriesLoading,
    getCategoriesLoading,
  } = useSetting();

  const [activeTab, setActiveTab] = useState("1");

  const uploadRef = useRef();

  const userProfile = useSelector((state) => state.app.userProfile);
  const userProfileLoading = useSelector(
    (state) => state.app.userProfileLoading,
  );

  const handleUploadFile = (e) => {
    if (e.target.files[0]) {
      updateAvatar(e.target?.files[0]);
    }
    e.target.value = null;
  };

  const items = [
    {
      key: "1",
      label: "Update account",
      children: (
        <section className="setting">
          <div>
            <div className="user_information_setting">
              <div>
                <div>
                  {loadings.updateAvatar ? (
                    <p>
                      <img src={LoadingBlack} alt="Loading..." />
                    </p>
                  ) : null}
                  {userProfileLoading ? (
                    <Skeleton
                      style={{ width: 80, height: 80, borderRadius: "50%" }}
                    />
                  ) : userProfile?.avatar ? (
                    <img src={showFile(userProfile?.avatar)} alt="avatar" />
                  ) : (
                    <span>
                      {userProfile?.fullname?.slice(0, 1).toUpperCase()}
                    </span>
                  )}
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleUploadFile}
                    hidden
                    ref={uploadRef}
                  />
                </div>
                {userProfileLoading ? (
                  <div>
                    <Skeleton
                      style={{ width: 120, height: 18, borderRadius: 5 }}
                    />
                    <Skeleton
                      style={{
                        width: 70,
                        height: 18,
                        borderRadius: 5,
                        margin: "8px 0",
                      }}
                    />
                    <Skeleton
                      style={{ width: 70, height: 18, borderRadius: 5 }}
                    />
                  </div>
                ) : (
                  <div>
                    <div
                      onClick={() => {
                        uploadRef.current?.click();
                      }}
                    >
                      Change avatar
                    </div>
                    <p>{userProfile?.instructor?.courseCount} Courses</p>
                    <p>{userProfile?.instructor?.enrollmentCount} Students</p>
                  </div>
                )}
              </div>
              <div className="rate_container">
                {userProfileLoading ? (
                  <Skeleton
                    style={{ width: 120, height: 18, borderRadius: 5 }}
                  />
                ) : (
                  <div>
                    <Rate
                      disabled
                      value={userProfile?.instructor?.rating?.toFixed(1)}
                    />
                    <span>({userProfile?.instructor?.rating?.toFixed(1)})</span>
                  </div>
                )}
                {userProfileLoading ? (
                  <Skeleton
                    style={{ width: 60, height: 17, borderRadius: 5 }}
                  />
                ) : (
                  <p>{userProfile?.instructor?.reviewCount} reveiw</p>
                )}
              </div>
            </div>
            <form
              onSubmit={updateSettingController.handleSubmit}
              className="form_setting"
            >
              <div className="name_expertise">
                {/* fullname */}
                <div className="name_form">
                  <label htmlFor="fullname">Name</label>
                  <Input
                    name="fullname"
                    id="fullname"
                    value={updateSettingController.values.fullname}
                    onChange={updateSettingController.handleChange}
                    disabled={userProfileLoading || loadings.updateSetting}
                    status={
                      updateSettingController.touched.fullname &&
                      updateSettingController.errors.fullname
                        ? "error"
                        : ""
                    }
                  />
                </div>
                {/* countryId */}
                <div className="country_form">
                  <label htmlFor="countryId">Country</label>
                  <Select
                    value={updateSettingController.values.countryId}
                    onChange={(value) => {
                      updateSettingController.setFieldValue("countryId", value);
                    }}
                    status={
                      updateSettingController.touched.countryId &&
                      updateSettingController.errors.countryId
                        ? "error"
                        : ""
                    }
                    showSearch={true}
                    filterOption={(input, option) =>
                      option?.label
                        ?.toString()
                        ?.toLowerCase()
                        .includes(input.toLowerCase())
                    }
                    disabled={userProfileLoading || loadings.updateSetting}
                    loading={getCountriesLoading}
                    options={countries?.map((country) => {
                      return {
                        label: `${country.flag} ${country.name}`,
                        value: country.id,
                      };
                    })}
                  />
                </div>
              </div>
              {/* expertises */}
              <div className="expertises">
                <label htmlFor="expertises">Expertises</label>
                <Select
                  value={updateSettingController.values.expertises}
                  onChange={(value) => {
                    updateSettingController.setFieldValue("expertises", value);
                  }}
                  status={
                    updateSettingController.touched.expertises &&
                    updateSettingController.errors.expertises
                      ? "error"
                      : ""
                  }
                  showSearch={true}
                  filterOption={(input, option) =>
                    option?.label
                      ?.toString()
                      ?.toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  mode="multiple"
                  disabled={userProfileLoading || loadings.updateSetting}
                  loading={getCategoriesLoading}
                  options={categories}
                />
              </div>
              {/* bio */}
              <div className="about_me">
                <label htmlFor="bio">About me</label>
                <TextArea
                  name="bio"
                  id="bio"
                  value={updateSettingController.values.bio}
                  onChange={updateSettingController.handleChange}
                  disabled={userProfileLoading || loadings.updateSetting}
                  status={
                    updateSettingController.touched.bio &&
                    updateSettingController.errors.bio
                      ? "error"
                      : ""
                  }
                  rows={4}
                />
              </div>
              <div className="phone_number_email_form">
                {/* mobile */}
                <div className="phone_number_form">
                  <label htmlFor="mobile">Mobile number</label>
                  <Input
                    name="mobile"
                    id="mobile"
                    value={updateSettingController.values.mobile}
                    onChange={updateSettingController.handleChange}
                    status={
                      updateSettingController.touched.mobile &&
                      updateSettingController.errors.mobile
                        ? "error"
                        : ""
                    }
                    disabled={userProfileLoading || loadings.updateSetting}
                  />
                </div>
                {/* email */}
                <div className="email_form">
                  <label htmlFor="email">Email</label>
                  <Input
                    name="email"
                    id="email"
                    value={updateSettingController.values.email}
                    onChange={updateSettingController.handleChange}
                    status={
                      updateSettingController.touched.email &&
                      updateSettingController.errors.email
                        ? "error"
                        : ""
                    }
                    disabled
                  />
                </div>
              </div>
              <div className="country_address_form">
                {/* gender */}
                <div className="country_form">
                  <label htmlFor="gender">Gender</label>
                  <Select
                    value={updateSettingController.values.gender}
                    onChange={(value) => {
                      updateSettingController.setFieldValue("gender", value);
                    }}
                    disabled={userProfileLoading || loadings.updateSetting}
                    status={
                      updateSettingController.touched.gender &&
                      updateSettingController.errors.gender
                        ? "error"
                        : ""
                    }
                    options={GendersEnum}
                  />
                </div>
                {/* address */}
                <div className="address_form">
                  <label>Address</label>
                  <Input
                    name="address"
                    id="address"
                    disabled={userProfileLoading || loadings.updateSetting}
                    value={updateSettingController.values.address}
                    onChange={updateSettingController.handleChange}
                    status={
                      updateSettingController.touched.address &&
                      updateSettingController.errors.address
                        ? "error"
                        : ""
                    }
                  />
                </div>
              </div>
              <div className="save_changes_btn">
                <Button
                  htmlType="submit"
                  loading={loadings.updateSetting}
                  disabled={userProfileLoading}
                >
                  Save Changes
                </Button>
              </div>
            </form>
          </div>
        </section>
      ),
    },
    {
      key: "2",
      label: "Social media accounts",
      children: (
        <section className="setting">
          <div>
            <p>
              Link your social media accounts to your profile, So that users can
              access them in the application.
            </p>
            {userProfileLoading ? (
              <div className={"social_media_boxes"}>
                {Array(6)
                  .fill()
                  .map((item, index) => (
                    <Skeleton key={index} className="social_media_box" />
                  ))}
              </div>
            ) : (
              <div className={"social_media_boxes"}>
                {/* add new account */}
                <div
                  onClick={() => {
                    setNewAccountModal(true);
                  }}
                  className="add_social_media_box"
                >
                  <FaPlus />
                  <div>Add new account</div>
                </div>
                {/* accounts */}
                {socialMediaAccounts?.map((account, index) => (
                  <div key={index} className="social_media_box">
                    <img
                      src={
                        InstructorSocialMediaEnum.find(
                          (o) => o.value == account.type,
                        )?.icon
                      }
                      alt={
                        InstructorSocialMediaEnum.find(
                          (o) => o.value == account.type,
                        )?.label
                      }
                    />
                    <a href={account.link} target="_blank">
                      Visit Account <FaExternalLinkAlt />
                    </a>
                    <p>
                      {
                        InstructorSocialMediaEnum.find(
                          (o) => o.value == account.type,
                        )?.label
                      }
                    </p>
                    <Dropdown
                      menu={{
                        items: [
                          {
                            key: "1",
                            label: "Edit link",
                          },
                          {
                            key: "2",
                            label: "Delete",
                            danger: true,
                          },
                        ],
                        onClick: ({ key }) => {
                          setSelectedSocialMedia(account);
                          if (key == "1") {
                            updateSocialMediaController.setFieldValue(
                              "type",
                              account.type,
                            );
                            updateSocialMediaController.setFieldValue(
                              "link",
                              account.link,
                            );
                            setUpdateAccountModal(true);
                          } else {
                            setDeleteAccountModal(true);
                          }
                        },
                      }}
                      trigger={["click"]}
                    >
                      <div>
                        <CiMenuKebab />
                      </div>
                    </Dropdown>
                  </div>
                ))}
              </div>
            )}
          </div>
        </section>
      ),
    },
    {
      key: "3",
      label: "Reset password",
      children: (
        <section className="setting">
          <div>
            <form
              onSubmit={updatePasswordController.handleSubmit}
              className="update_password_form"
            >
              <div>
                {/* currentPassword */}
                <div className="password_form_field">
                  <label htmlFor="currentPassword">Current password</label>
                  <Input.Password
                    name="currentPassword"
                    id="currentPassword"
                    value={updatePasswordController.values.currentPassword}
                    onChange={updatePasswordController.handleChange}
                    disabled={loadings.updatePassword}
                    status={
                      updatePasswordController.touched.currentPassword &&
                      updatePasswordController.errors.currentPassword
                        ? "error"
                        : ""
                    }
                  />
                </div>
                {/* newPassword */}
                <div className="password_form_field">
                  <label htmlFor="newPassword">New password</label>
                  <Input.Password
                    name="newPassword"
                    id="newPassword"
                    value={updatePasswordController.values.newPassword}
                    onChange={updatePasswordController.handleChange}
                    disabled={loadings.updatePassword}
                    status={
                      updatePasswordController.touched.newPassword &&
                      updatePasswordController.errors.newPassword
                        ? "error"
                        : ""
                    }
                  />
                </div>
                {/* newPasswordConfirm */}
                <div className="password_form_field">
                  <label htmlFor="newPasswordConfirm">
                    New password confirmation
                  </label>
                  <Input.Password
                    name="newPasswordConfirm"
                    id="newPasswordConfirm"
                    value={updatePasswordController.values.newPasswordConfirm}
                    onChange={updatePasswordController.handleChange}
                    disabled={loadings.updatePassword}
                    status={
                      updatePasswordController.touched.newPasswordConfirm &&
                      updatePasswordController.errors.newPasswordConfirm
                        ? "error"
                        : ""
                    }
                  />
                </div>
              </div>

              <div className="save_changes_btn">
                <Button htmlType="submit" loading={loadings.updatePassword}>
                  Update Password
                </Button>
              </div>
            </form>
          </div>
        </section>
      ),
    },
  ];

  useEffect(() => {
    getCountries();
    getCategories();
  }, []);

  useEffect(() => {
    if (!newAccountModal) {
      addSocialMediaController.resetForm();
    }
  }, [newAccountModal]);

  useEffect(() => {
    if (!updateAccountModal) {
      updateSocialMediaController.resetForm();
    }
  }, [updateAccountModal]);

  return (
    <Layout>
      <Tabs
        className="course_preview_tabs"
        activeKey={activeTab}
        onChange={(key) => {
          setActiveTab(key);
        }}
        items={items}
      />
      {/* new account modal */}
      <Modal
        open={newAccountModal}
        onCancel={() => {
          setNewAccountModal(false);
        }}
        footer={null}
        className="sharetModal"
        closeIcon={null}
      >
        <form
          onSubmit={addSocialMediaController.handleSubmit}
          className="share_modal_container"
        >
          <div className="share_modal_title">
            <Button
              onClick={() => {
                setNewAccountModal(false);
              }}
              disabled={loadings.createPost}
            >
              <IoClose />
            </Button>
            <h3>New social media account</h3>
          </div>
          <div className="social_media_form">
            {/* type */}
            <div>
              <label htmlFor="type">Platform</label>
              <Select
                options={InstructorSocialMediaEnum.map((item) => {
                  return {
                    ...item,
                    disabled: socialMediaAccounts?.find(
                      (o) => o.type == item.value,
                    )
                      ? true
                      : false,
                  };
                })}
                value={addSocialMediaController.values.type}
                placeholder="Select"
                disabled={loadings.addSocialMedia}
                onChange={(value) => {
                  addSocialMediaController.setFieldValue("type", value);
                }}
                status={
                  addSocialMediaController.touched.type &&
                  addSocialMediaController.errors.type
                    ? "error"
                    : ""
                }
                // dropdown options
                optionRender={(option) => (
                  <div
                    style={{ display: "flex", alignItems: "center", gap: 12 }}
                  >
                    <img
                      src={option.data.icon}
                      alt={option.data.label}
                      width={20}
                      height={20}
                    />
                    <span>{option.data.label}</span>
                  </div>
                )}
                // selected value
                labelRender={(option) => {
                  const selected = InstructorSocialMediaEnum.find(
                    (item) => item.value === option.value,
                  );

                  return (
                    <div
                      style={{ display: "flex", alignItems: "center", gap: 12 }}
                    >
                      <img
                        src={selected?.icon}
                        alt={selected?.label}
                        width={20}
                        height={20}
                      />
                      <span>{selected?.label}</span>
                    </div>
                  );
                }}
              />
            </div>
            {/* link */}
            <div>
              <label htmlFor="link">Account link</label>
              <Input
                name="link"
                id="link"
                onChange={addSocialMediaController.handleChange}
                value={addSocialMediaController.values.link}
                placeholder="Enter your platform link"
                disabled={loadings.addSocialMedia}
                status={
                  addSocialMediaController.touched.link &&
                  addSocialMediaController.errors.link
                    ? "error"
                    : ""
                }
              />
            </div>
          </div>

          {/* post_btn */}
          <div className="post_btn">
            <Button loading={loadings.addSocialMedia} htmlType="submit">
              Add account
            </Button>
            <Button
              disabled={loadings.addSocialMedia}
              onClick={() => {
                setNewAccountModal(false);
              }}
            >
              Cancel
            </Button>
          </div>
        </form>
      </Modal>
      {/* update account modal */}
      <Modal
        open={updateAccountModal}
        onCancel={() => {
          setUpdateAccountModal(false);
        }}
        footer={null}
        className="sharetModal"
        closeIcon={null}
      >
        <form
          onSubmit={updateSocialMediaController.handleSubmit}
          className="share_modal_container"
        >
          <div className="share_modal_title">
            <Button
              onClick={() => {
                setUpdateAccountModal(false);
              }}
              disabled={loadings.updateSocialMedia}
            >
              <IoClose />
            </Button>
            <h3>Edit social media account link</h3>
          </div>
          <div className="social_media_form">
            {/* link */}
            <div>
              <label htmlFor="link">Account link</label>
              <Input
                name="link"
                id="link"
                onChange={updateSocialMediaController.handleChange}
                value={updateSocialMediaController.values.link}
                placeholder="Enter your platform link"
                disabled={loadings.updateSocialMedia}
                status={
                  updateSocialMediaController.touched.link &&
                  updateSocialMediaController.errors.link
                    ? "error"
                    : ""
                }
              />
            </div>
          </div>

          {/* post_btn */}
          <div className="post_btn">
            <Button loading={loadings.updateSocialMedia} htmlType="submit">
              Update link
            </Button>
            <Button
              disabled={loadings.updateSocialMedia}
              onClick={() => {
                setNewAccountModal(false);
              }}
            >
              Cancel
            </Button>
          </div>
        </form>
      </Modal>
      {/* delete account modal */}
      <Modal
        open={deleteAccountModal}
        onCancel={() => {
          setDeleteAccountModal(false);
        }}
        footer={null}
        className="sharetModal"
        closeIcon={null}
      >
        <div className="share_modal_container">
          <div className="share_modal_title">
            <Button
              onClick={() => {
                setDeleteAccountModal(false);
              }}
              disabled={loadings.deleteSocialMedia}
            >
              <IoClose />
            </Button>
            <h3>Delete social media account</h3>
          </div>
          <div className="social_media_delete">
            Are you sure you want to delete this social media account from your
            profile?
          </div>
          {/* post_btn */}
          <div className="post_btn">
            <Button
              onClick={() => {
                deleteSocialMedia(selectedSocialMedia);
              }}
              loading={loadings.deleteSocialMedia}
              htmlType="button"
            >
              Yes, Delete
            </Button>
            <Button
              disabled={loadings.deleteSocialMedia}
              onClick={() => {
                setDeleteAccountModal(false);
              }}
            >
              Cancel
            </Button>
          </div>
        </div>
      </Modal>
    </Layout>
  );
};

export default Setting;
